export default __webpack_public_path__ + "static/media/window_restore.2a881bfe.svg";